<template>
  <div class="cmd0060-container">
    <PageHeaderBanner>
      <template #title>ATTOID一覧</template>
    </PageHeaderBanner>
    <q-form autofocus greedy @submit.prevent="pushSearchBtn">
      <q-expansion-item v-model="open" header-style="display:none">
        <div class="cmd0060-conditions-form">
          <q-card style="background: var(--q-lightGray)" flat bordered>
            <q-card-section>
              <div class="row q-gutter-x-md">
                <div class="col" style="max-width: 450px">
                  <label>構造式</label>
                  <iframe
                    id="sketch-iframe"
                    ref="sketch-iframe"
                    data-toolbars="reporting"
                    title="marvin js editor"
                    src="../../sketch/editorws.html"
                    style="overflow: hidden; width:100%; height: 100% min-width: 500px; min-height: 350px; border: 1px solid darkgray"
                  ></iframe>
                </div>
                <div class="column row align-end justify-between attoid-input-area">
                  <div>
                    <label>ATTO_ID</label>
                    <q-input
                      v-model="atto_id"
                      outlined
                      dense
                      maxlength="12"
                      style="background: var(--q-white); padding: 0"
                      class="input-area"
                      lazy-rules
                      @keydown.enter.prevent
                    />
                  </div>
                  <div class="col">
                    <q-checkbox
                      v-model="errorOnly"
                      label="法規制チェックエラーのみを表示"
                      style="height: 70px"
                    />
                  </div>
                  <div class="row q-gutter-x-xs flex justify-end">
                    <q-btn
                      color="primary"
                      style="width: 150px"
                      label="検索"
                      icon="mdi-magnify"
                      type="submit"
                    />
                    <q-btn
                      outline
                      style="
                        width: 150px;
                        background: var(--q-white) !important;
                        color: var(--q-delete);
                      "
                      icon="mdi-eraser"
                      label="クリア"
                      @click="clear"
                    />
                  </div>
                </div>
              </div>
            </q-card-section>
          </q-card>
        </div>
      </q-expansion-item>
    </q-form>
    <SearchOpenCloseButton
      :display="searchResult"
      :open="open"
      style="margin-bottom: 20px"
      @open="open = $event"
    />
    <div ref="searchResultElement" class="cmd0060-result-table">
      <div
        :class="
          'chem-table-area btn-exist table-top-button ' + (rows.length === 0 ? 'table-nodata' : '')
        "
      >
        <q-table
          class="my-sticky-header-column-table"
          :rows="rows"
          :columns="columns"
          row-key="index"
          flat
          dense
          separator="cell"
          :no-data-label="tableMessage"
          :rows-per-page-options="[10, 20, 50, 0]"
          rows-per-page-label="件表示"
          :pagination-label="
            (firstRowIndex, endRowIndex, totalRowsNumber) => {
              return `${totalRowsNumber} 件中 ${firstRowIndex}～${endRowIndex} 件表示`;
            }
          "
        >
          <template #no-data="{ message }">
            <div class="full-width row q-gutter-sm">
              <q-icon size="24px" name="mdi-alert-circle-outline" />
              <span class="q-pt-xs">{{ message }}</span>
            </div>
          </template>
          <template #top>
            <div class="add-btn-area flex items-center filter-select">
              <q-btn
                icon="mdi-plus"
                label="追加"
                class="add-btn"
                color="primary"
                @click="registerData"
              />
            </div>
          </template>
          <!-- 削除Header -->
          <template #header-cell-delete>
            <q-th class="table-btn-area"></q-th>
          </template>
          <!-- 削除Body -->
          <template #body-cell-delete="cell">
            <q-td class="table-btn-area">
              <div class="flex">
                <q-btn
                  icon="mdi-close"
                  label="削除"
                  color="primary"
                  class="deletebtn"
                  outline
                  style="color: var(--q-delete)"
                  @click="deleteDialog(cell.row.atto_id)"
                />
              </div>
            </q-td>
          </template>
          <!-- 構造式Body -->
          <template #body-cell-structure="structure">
            <q-td
              style="
                padding: 2px;
                min-width: 180px;
                max-width: 180px;
                width: 180px;
                min-height: 180px;
              "
            >
              <AtomImage :exatoms="structure.row.structure" />
            </q-td>
          </template>
          <template #body-cell="cell">
            <q-td :props="cell">
              <div class="flex items-start">
                <p class="q-mb-none">
                  {{ cell.value }}
                </p>
              </div>
            </q-td>
          </template>
        </q-table>
      </div>
    </div>
    <!--検索条件エラーの場合のダイアログ-->
    <AlertDialog
      :display="isSearchDisplayFlg"
      level="error"
      confirmation
      :title="dialogTitle"
      :text="dialogText"
      @complete="isSearchDisplayFlg = false"
    />
    <!--削除確認ダイアログ-->
    <AlertDialog
      :display="dialogFlg"
      :level="dialogLevel"
      :confirmation="dialogConfFlg"
      :title="dialogTitle"
      :text="dialogText"
      @confirm="deleteAttoId"
      @complete="dialogFlg = false"
      @close="dialogFlg = false"
    />
    <!-- 削除完了ダイアログ -->
    <AlertDialog
      :display="deleteDialogFlg"
      :level="dialogLevel"
      :confirmation="dialogConfFlg"
      :title="dialogTitle"
      :text="dialogText"
      @complete="compDelete"
      @close="deleteDialogFlg = false"
    />
    <!-- 検索件数超過ダイアログ -->
    <AlertDialog
      :display="resultOverFlg"
      level="warning"
      confirmation
      :title="dialogTitle"
      :text="dialogText"
      @complete="closeDialog"
      @close="resultOverFlg = false"
    />
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { Loading } from 'quasar';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import SearchOpenCloseButton from '../../components/button/SearchOpenCloseButton.vue';
import AtomImage from '../../components/images/AtomImage.vue';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import axios from '../../common/axios-common';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import { clearMarvin, getMarvin } from '../../common/marvin-js';
import messages from '../../messages/message.json';

// 検索結果
interface Result {
  atto_id: string;
  structure: string;
  reg_group_name: string;
  reg_structure_name: string;
  reg_category_name: string;
  reg_error: string;
  excluded_flag: string;
  create_user_name: string;
  create_timestamp: string;
}

// カラム
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const columns: Array<any> = [
  {
    name: 'delete',
  },
  {
    name: 'atto_id',
    label: 'ATTO_ID',
    align: 'left',
    field: 'atto_id',
    style: 'width: 100px',
    sortable: true,
  },
  {
    name: 'structure',
    label: '構造',
    align: 'left',
    field: 'structure',
    classes: 'cmd0060-structure',
    headerClasses: 'cmd0060-structure',
  },
  {
    name: 'reg_group_name',
    label: '法規制情報　分類グループ名',
    align: 'left',
    field: (row: Result) => (row.excluded_flag === '1' ? '－' : row.reg_group_name),
    sortable: true,
    style: 'white-space: pre',
  },
  {
    name: 'reg_structure_name',
    label: '法規制情報　物質名',
    align: 'left',
    field: (row: Result) => (row.excluded_flag === '1' ? '－' : row.reg_structure_name),
    sortable: true,
    style: 'white-space: pre',
  },
  {
    name: 'reg_category_name',
    label: '法規制情報　分類名',
    align: 'left',
    field: (row: Result) => (row.excluded_flag === '1' ? '－' : row.reg_category_name),
    sortable: true,
    style: 'white-space: pre',
  },
  {
    name: 'reg_error',
    label: '法規制チェックエラー内容',
    align: 'left',
    field: 'reg_error',
    sortable: true,
  },
  {
    name: 'create_user_name',
    label: '登録者',
    align: 'left',
    field: 'create_user_name',
    sortable: true,
  },
  {
    name: 'create_timestamp',
    label: '登録日時',
    align: 'left',
    field: 'create_timestamp',
    style: 'width: 120px',
    sortable: true,
  },
];

// カラムプルダウン開閉
const open = ref(true);

// 検索結果フラグ
const searchResult = ref(false);

const router = useRouter();

// テーブルメッセージ
const tableMessage = ref('検索してください。');

// ダイアログのdisplayFlg(表示判断)
const dialogFlg = ref(false);

// ダイアログのlevel
const dialogLevel = ref('');

// ダイアログのtitle
const dialogTitle = ref('');

// ダイアログのtext
const dialogText = ref(['']);

// ダイアログのconfirmation(trueならキャンセルボタンを表示しない)
const dialogConfFlg = ref(true);

// 検索条件エラーダイアログフラグ
const isSearchDisplayFlg = ref<boolean>(false);

// 削除完了ダイアログフラグ
const deleteDialogFlg = ref<boolean>(false);

// 検索結果上限超過フラグ
const resultOverFlg = ref<boolean>(false);

// 検索結果要素
const searchResultElement = ref<HTMLImageElement>();

// atto_id
const atto_id = ref('');

// 検索用ATTOID
const searchId = ref('');

// 削除用ATTOID
const delAttoId = ref('');

// 検索用構造式
const searchStructure = ref('');

// 検索条件：法規制チェックエラーのみを表示
const errorOnly = ref(false);

// 検索用法規制チェックエラー
const searchErrorOnly = ref(false);

// 取得したデータ
const data = ref<Array<Result>>([]);

// 出力用データ
const rows = ref<Array<Result>>(data.value);

// ダイアログ閉じる
const closeDialog = () => {
  resultOverFlg.value = false;
  setTimeout(() => searchResultElement.value?.scrollIntoView(true), 600);
};

/**
 * 削除確認ダイアログ
 *
 * @param id 削除対象のATTOID
 */
const deleteDialog = (id: string) => {
  delAttoId.value = id;
  dialogFlg.value = true;
  dialogConfFlg.value = false;
  dialogTitle.value = '削除確認';
  dialogLevel.value = 'warning';
  dialogText.value = [`${delAttoId.value}を削除します。`, `よろしいですか？`];
};

/**
 * 検索件数超過ダイアログ
 *
 * @param {number} searchNumTotal 最大検索件数
 */
const checkOverResult = (searchNumTotal: number) => {
  if (searchNumTotal > Number(messages.ja.validation.search_max_count)) {
    resultOverFlg.value = true;
    dialogLevel.value = 'warning';
    dialogConfFlg.value = true;
    dialogTitle.value = '検索結果上限値超過';
    dialogText.value = [
      `先頭から${messages.ja.validation.search_max_count}件までの検索結果を表示しています。`,
      'お探しの化合物が見つからない場合、検索条件を絞り込んで再度検索してください。',
    ];
  }
};

// 検索
const searchAttoId = () => {
  dialogFlg.value = false;
  // Loading Start
  Loading.show();
  // バックエンド側にデータを連携
  const formData = new FormData();
  formData.append('atto_id', searchId.value);
  formData.append('structure', searchStructure.value !== undefined ? searchStructure.value : '');
  formData.append('errorOnly', searchErrorOnly.value.toString());

  // 検索実行
  axios
    .post('/cmd006001/searchAttoId', formData)
    .then((response) => {
      switch (response.data.common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          data.value = response.data.attoIdList;
          rows.value = data.value;
          searchResult.value = true;
          checkOverResult(response.data.searchNumTotal);
          tableMessage.value = 'データがありません。';
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (response.data.common.detail_status) {
            // タイムアウトの場合
            case DetailResultStatusCode.STATEMENT_TIMEOUT:
              dialogTitle.value = '検索時間超過エラー';
              dialogText.value = [`検索時間が上限に達しました。条件を見直して再検索してください。`];
              isSearchDisplayFlg.value = true;
              break;
            // システムエラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;
            default:
          }
          break;
        // その他のエラーの場合
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        //  エラー画面に遷移
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
      // スクロール
      setTimeout(() => searchResultElement.value?.scrollIntoView(true), 600);
    });
};

// 検索ボタン押下時
const pushSearchBtn = () => {
  searchId.value = atto_id.value;
  getMarvin().then((structure: string) => {
    // MarvinJs読み込み失敗
    if (structure === 'error') {
      dialogFlg.value = true;
      dialogLevel.value = 'error';
      dialogConfFlg.value = true;
      dialogTitle.value = 'MarvinJs読み込みエラー';
      dialogText.value = ['構造式の取得に失敗しました。', '画面を開き直して再度お試しください。'];
    }
    searchStructure.value = structure;
    searchErrorOnly.value = errorOnly.value;
    searchAttoId();
  });
};

// 削除
const deleteAttoId = async () => {
  dialogFlg.value = false;
  // Loading Start
  Loading.show();
  // バックエンド側にデータを連携
  const formData = new FormData();
  formData.append('atto_id', delAttoId.value);
  // 削除
  await axios
    .post('/cmd006001/deleteAttoId', formData)
    .then((response) => {
      const { common } = response.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // 削除完了ダイアログ表示
          deleteDialogFlg.value = true;
          // 削除完了ダイアログレベル
          dialogLevel.value = 'information';
          // 削除確認ダイアログのtitleを設定
          dialogTitle.value = '削除完了';
          // 削除確認ダイアログのtextを生成
          dialogText.value = [common.message];
          // ダイアログのボタン数判断をtrue(1つ)に
          dialogConfFlg.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.UPDATE_ERROR:
              // 削除対象が存在しない場合
              dialogFlg.value = true;
              dialogConfFlg.value = true;
              dialogTitle.value = '削除エラー';
              dialogLevel.value = 'error';
              dialogText.value = [common.message];
              break;
            case DetailResultStatusCode.SYSTEM_ERROR:
            case DetailResultStatusCode.PARAMETER_ERROR:
              router.push({ name: 'error' });
              break;
            default:
          }
          break;
        // その他のエラーの場合
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他のエラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

// 削除完了ダイアログ押下時
const compDelete = () => {
  deleteDialogFlg.value = false;
  searchAttoId();
};

// 検索条件クリア
const clear = () => {
  clearMarvin().then((err: string) => {
    // MarvinJs読み込み失敗
    if (err === 'error') {
      dialogFlg.value = true;
      dialogLevel.value = 'error';
      dialogConfFlg.value = true;
      dialogTitle.value = 'MarvinJs読み込みエラー';
      dialogText.value = ['構造式のクリアに失敗しました。', '画面を開き直して再度お試しください。'];
    }
  });
  atto_id.value = '';
  errorOnly.value = false;
};

// 追加ボタン押下時
const registerData = () => {
  router.push({ name: 'attoIdRegist' });
};
</script>
<style scoped>
.cmd0060-conditions-form {
  width: 70%;
  margin: 0 auto 20px;
}
.cmd0060-result-table {
  margin: -60px auto 0;
  padding-top: 60px;
  width: 90%;
}
.attoid-input-area {
  width: calc(100% - 450px);
}
</style>
<style>
.cmd0060-structure {
  min-width: 180px;
  max-width: 180px;
  width: 180px;
}
</style>
